import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { formatNumber, getISO2ByISO3, getNameByISO3 } from "../../../../libs/misc";
import useFetch from "../../../../libs/useFetch";
import DataTable from "../../../../../ui-kit/DataTable/DataTable";
import { Link } from "react-router-dom";

interface DataRow {
  hs: string;
  hs_description: string;
  ave_max: number
}

type ListBoundTariffTableProps = {
  data: Array<DataRow>
  isLoading: boolean
}

const columnHelper = createColumnHelper<DataRow>();

const ListBoundTariffTable: FC<ListBoundTariffTableProps> = ({
  data=[],
  isLoading
}) => {
  const [dataTable, setDataTable] = useState<DataRow[]>([]);
  const [rawData, setRawData] = useState<any[]>([]);

  useEffect(()=>{
    if(data.length>0){
      setDataTable(data)
    }
  },[data])

  const columns: ColumnDef<DataRow, any>[] = useMemo(() => [
    columnHelper.accessor('hs', {
      header: 'Commodity',
      cell: info => (
        <span className='badge text-white bg-dark'>{info.getValue()}</span>
      ),
      meta: {
        headerClass: 'w-100px text-center',
        cellClass: 'text-center',
      },
      enableSorting: true,
      enableGlobalFilter: true,
    }),
    columnHelper.accessor('hs_description', {
      header: 'Description',
      cell: info => info.getValue(),
      meta: {
        headerClass: '',
        cellClass: '',
      },
      enableSorting: true,
      enableGlobalFilter: true,
    }),
    columnHelper.accessor('ave_max', {
      header: 'Tariff',
      cell: info => `${Math.round(info.getValue())}%`,
      meta: {
        cellClass: 'text-end',
        headerClass: 'font-bold'
      },
      enableSorting: true,
      enableGlobalFilter: true,
    }),
  ], []); 
  
  return (
    <>
      <DataTable<DataRow>
        data={dataTable}
        columns={columns}
        isLoading={isLoading}
        enablePagination={true}
        enableSorting={true}
        enableGlobalFilter={true}
        globalFilterPlaceholder=""
        defaultPageSize={20}
        pageSizes={[5, 10, 20, 50, 100]}
        className="my-custom-table-wrapper"
        initialSortBy={{ id: 'hs', desc: false }} 
      />
    </>
  )
}

export default ListBoundTariffTable;